<template>
  <div
    class="rounded-full relative"
    :class="[
      {
        'p-0.5': size === 'small',
        'p-1': size === 'medium',
        'p-4': size === 'large',
      },
      backgroundColor,
    ]"
  >
    <NegarMoonIcon
      v-if="tradingStateCode === TRADING_STATE_CODES.closed"
      class="text-purple-primary"
      :size="iconSize"
    />

    <NegarClockIcon
      v-else-if="tradingStateCode === TRADING_STATE_CODES.preOpening"
      class="text-warning-secondary"
      :size="iconSize"
    />

    <NegarCircleIcon
      v-else-if="tradingStateCode === TRADING_STATE_CODES.open"
      class="text-brand-primary"
      :size="iconSize"
    />

    <div v-else-if="tradingStateCode === TRADING_STATE_CODES.forbidden">
      <NegarMoonIcon class="text-purple-primary" :size="iconSize" />

      <span
        class="flex items-center justify-center bg-neutral-primary rounded-full absolute right-0 bottom-0 pointer-events-none"
        :class="badgeClass"
      >
        <span class="bg-critical-primary rounded-full w-1/2 h-1/2" />
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { NegarClockIcon, NegarCircleIcon, NegarMoonIcon } from '@negar/icons';
import { TRADING_STATE_CODES } from '@core/symbol';

import { TRADING_STATE_INFO } from '@/modules/symbol';

type SymbolTradeStateIconPropsType = {
  tradingStateCode: number;
  size?: 'small' | 'medium' | 'large';
};

const props = withDefaults(defineProps<SymbolTradeStateIconPropsType>(), {
  size: 'small',
});

const backgroundColor = computed(
  () => TRADING_STATE_INFO[props.tradingStateCode].bgColor
);

const iconSize = {
  small: 7,
  medium: 8,
  large: 40,
}[props.size];

const badgeClass = {
  small: 'w-1 h-1',
  medium: 'w-1.5 h-1.5',
  large: 'w-6 h-6',
}[props.size];
</script>
